import { useTheme } from '@mui/material/styles';

import { CardFieldsContainerProps } from 'payments/components/CardField';
import {
  CardField,
  type InputLabelPropsSxProps,
  useCardFieldProps
} from 'payments/components/CardField';

export const CommerceHubCardField = ({
  fieldState,
  ...props
}: CardFieldsContainerProps) => {
  const { error, isEmpty, isFocused, ...cardFieldProps } = useCardFieldProps();
  const theme = useTheme();

  let InputLabelPropsSx = {
    marginTop: '5px'
  };

  let InputPropsSx = {
    'padding-right': 0,

    '&.MuiInputBase-root': {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'inherit'
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.primary}`,
        borderWidth: '1px'
      }
    },
    '&.MuiOutlinedInput-root': {
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f'
      }
    }
  };

  if (fieldState?.isFocused) {
    InputPropsSx = {
      ...InputPropsSx,
      '&.MuiInputBase-root': {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.primary.main}`
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.primary.main}`,
          borderWidth: '2px'
        }
      }
    };
    InputLabelPropsSx = {
      color: theme.palette.primary.main,
      marginTop: '0'
    } as InputLabelPropsSxProps;
  }

  return (
    <CardField
      error={error || (fieldState?.error ?? null)}
      isEmpty={isEmpty && (fieldState?.isEmpty ?? true)}
      isFocused={isFocused || (fieldState?.isFocused ?? false)}
      InputPropsSx={InputPropsSx}
      InputLabelPropsSx={InputLabelPropsSx}
      {...props}
      {...cardFieldProps}
    />
  );
};
